export default {
    signIn: {
        title: "ยินดีต้อนรับกลับ",
        subtitle: "เข้าสู่ระบบเพื่อดำเนินการต่อไปยัง Pitango Market",
        emailLabel: "อีเมล",
        emailPlaceholder: "you@example.com",
        passwordLabel: "รหัสผ่าน",
        passwordPlaceholder: "รหัสผ่านของคุณ",
        showPassword: "แสดง",
        hidePassword: "ซ่อน",
        submit: "เข้าสู่ระบบ",
        submitting: "กำลังเข้าสู่ระบบ…",
        forgotPassword: "ลืมรหัสผ่าน?",
        noAccount: "ยังไม่มีบัญชี?",
        signUpLink: "สร้างบัญชี",
        validation: {
            emailRequired: "กรุณากรอกอีเมล",
            emailInvalid: "กรุณากรอกอีเมลที่ถูกต้อง",
            passwordRequired: "กรุณากรอกรหัสผ่าน",
            passwordLength: "รหัสผ่านต้องมีอย่างน้อย {{min}} ตัวอักษร"
        },
        errors: {
            wrongCredentials: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
            emailNotVerified: "กรุณายืนยันอีเมลก่อนเข้าสู่ระบบ",
            passwordResetRequired: "คุณต้องตั้งรหัสผ่านใหม่ก่อนเข้าสู่ระบบ",
            generic: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
        },
        resend: {
            action: "ส่งอีเมลยืนยันอีกครั้ง",
            sent: "ส่งอีเมลยืนยันแล้ว"
        }
    }
} as const;
